import React from 'react';
import Style from '../assets/css/shareButton.module.css'

const SocialShareButton = ({ url, title }) => {
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    url: url
                });
            } catch (error) {
                console.error('Error al compartir:', error);
            }
        } else {
            alert('La funcionalidad de compartir no es compatible en este navegador.');
        }
    };

    return (
        <button onClick={handleShare} className={Style.shareButton}>Compartir este artículo</button>
    );
};

export default SocialShareButton;
